import React from 'react';

export default function PaymentDialogClose({ onClose, disabled = false }: { onClose: () => void; disabled?: boolean }) {
  return <button type="button" aria-label="Close dialog" disabled={disabled} onClick={onClose} className="absolute right-0 top-0 flex h-11 w-11 items-center justify-center rounded-full bg-slate-100 text-slate-600 hover:bg-slate-200 hover:text-slate-900 focus-visible:outline focus-visible:outline-2 focus-visible:outline-[#006dcc] disabled:opacity-40">
    <svg aria-hidden="true" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"><path d="m6 6 12 12M18 6 6 18" /></svg>
  </button>;
}
